module.exports = __webpack_public_path__ + "888c7e0457a4b06409a37defeb428023.pdf";